export const en = {
  // terms of use
  terms_of_use: {
    title: 'Terms of use',
    subtitle: 'By starting use, you agree to the ',
    link: 'terms of use.',
    button_text: 'To accept',
  },

  // main page
  main_page: {
    stars: 'STARS',
    pending: 'Pending',
    available: 'Available',
    replenish: 'Replenish',
    send: 'Send',
    bring_out: 'Withdraw',
    history_of_transactions: 'Transaction History',
    total_balance: 'Total Balance',
  },

  // menu
  menu: {
    language: 'Language',
    delete_data: 'Delete Data',
    enter_promo_code: 'Enter Promo Code',
    ton_wallet: 'Ton Wallet',
    support: 'Support',
    exit: 'Exit',
    history_of_transaction: 'History of transactions',
  },

  // languages page
  language_page: {
    ukrainian: 'Ukrainian',
    english: 'English',
    russian: 'Russian',
    german: 'German',
    choose: 'Choose',
  },

  // delete page
  delete_page: {
    title: 'What will be lost when deleting the account?',
    warning: '*by clicking the button, you agree to the consequences.',
    delete: 'Delete',
    item_1: 'all active sessions will be terminated.',
    item_2: 'account recovery will not be possible.',
    item_3: 'all completed transactions will be lost.',
    item_4: 'funds remaining in your balance will not be refundable.',
  },

  // promo code page
  promo_code: {
    input_promo_below: 'Enter your promo code below to receive a gift.',
    promo: 'Promo Code',
    input_promo: 'Enter Promo Code',
    recieve: 'Receive',
  },

  // info container
  info_container: {
    ton_wallet: {
      connected: 'Connected',
      not_connected: 'Not Connected',
      wallet_is_connected: 'Your wallet has been successfully connected.',
      wallet_is_not_connected: 'Currently, your wallet is not connected. Use the button below.',
      connect: 'Connect',
      turn_off_question: 'Want to disconnect?',
    },
    support: {
      need_help_question: 'Need help?',
      contact_our_bot: 'Contact our bot, and we will resolve your issue quickly.',
      write_bot: 'Write to Bot',
    },
    go_out: {
      want_exit_question: 'Want to exit?',
      you_can_sign_in_again: 'You can sign in again at any time.',
      log_out_of_account: 'Log Out of Account',
    },
  },

  // bottles page
  bottles_page: {
    bottles: 'Bottles',
    filter: 'Filter',
    create_bank: 'Create Bank',
    types: {
      my: 'My',
      participate: 'Participating',
      lottery: 'Lottery',
      charitable: 'Charitable',
    },
    conditions: {
      star_on_tickets_exchange: '1 Star = 20 tickets',
      max_stars: 'Daily limit: 10 Stars = 200 tickets',
      advertising_on_ticket_exchange: '1 ad view = 1 ticket',
      max_advertising: 'Limit: 100 ads per day (10 ads per hour)',
    },
  },

  // main bottle item
  main_bottle_item: {
    collected: 'Collected',
    to_end: 'To End',
    participants: 'Participants',
    daily_lottery: 'Daily Lottery',
    viewing_ads: 'Viewing Ads',
    modal: {
      tickets: 'Tickets on balance:',
      how_works: 'How does the lottery work?',
      description:
        'Only those who have collected tickets — through exchanging Stars or watching ads — participate in the daily lottery.',
      item_1: '5 participants will receive 10% of the prize pool each.',
      item_2: '50 random participants will win 1% of the prize each.',
      item_3: 'The lottery is held automatically every day at 00:00.',
      exchange: 'Exchange for tickets',
      advertising: 'Advertising tickets',
      views: 'Available views:',
    },
  },

  // bottle item
  bottle_item: {
    start_is_expected: 'Start is Expected',
    fixed: 'fixed',
    any: 'any',
  },

  type_of_bottle: {
    lottery: {
      name: 'Lottery',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
    charitable: {
      name: 'Charitable',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
    button: {
      text: 'Continue',
    },
  },

  create_bottle: {
    step: 'Step {{step}}',
    choose_type_bank: 'Choose the type of bank',
    input_name_bank: 'Enter the name of the bank',
    input_target_bank: 'Enter the target of the bank',
    input_desired_amount: 'Enter the desired entry amount',
    input_availability_period: 'Enter the bank availability period',
    three_months_maximum: '(3 months maximum)',
    set_date: 'Set a date',
    continue: 'Continue',
    on: 'On ',
    from: 'from',
    to: 'to',
    confirm_page: {
      title: 'Check the data carefully!',
      subtitle: 'Once the bank is saved, it cannot be edited or deleted.',
    },
    popup: {
      text: 'Enter the desired entry amount or skip this step to create a jar with any entry amount.',
    },
  },

  attachment_to_bottle: {
    join_to_bottle: 'Join the bottle',
    input_amount: 'Enter the desired contribution amount to participate.',
    button: {
      text: 'Make a contribution',
    },
    conditional: {
      depositing: 'Deposit contribution',
      text: 'By clicking “Deduct Stars” on this screen, the specified number of stars will be deducted from your account to participate in this bottle.',
      reset_stars: 'Deduct Stars',
      cancel: 'Cancel',
    },
  },

  status_page: {
    confirmation: {
      title: 'Bank Created',
      subtitle: 'Your bank has been successfully created and is ready to use.',
      link_text: 'Go to Home',
    },
    error: {
      title: 'Date exceeds allowed limit',
      subtitle: 'You have specified a date that exceeds 3 months. Please try again.',
      link_text: 'Try Again',
    },
    show_bottles: 'View Banks',
  },

  skip: {
    pretermit: 'Skip',
  },

  // NoBottles page
  no_bottles_page: {
    reset_filters: 'Reset Filters',
    nothing: {
      title: 'Nothing Found',
      subtitle: 'Try changing the filters for better results.',
    },
    no_own_bottles: {
      title: 'No Own Bottles',
      subtitle: 'Create a bottle right now using the button below.',
    },
    no_participations: {
      title: 'No Participations in Bottles',
      subtitle: 'To join a bottle, get a link from one of its participants.',
    },
  },

  // Filters block
  filters: {
    fixed: 'Fixed',
    any: 'Any',
    active: 'Active',
    planned: 'Planned',
    cancel: 'Cancel',
    type_of_deposit: 'Type of Deposit',
    number_of_participants: 'Number of Participants',
    up_to_number: 'up to {{number}}',
    more_than_number: 'more than {{number}}',
    time_of_bank: 'Time of Bank',
    apply: 'Apply',
  },

  // bottle page
  bottle_page: {
    before_the_start: 'Time Left Before Start',
    total_pool: 'Total Pool',
    list_of_participants: 'List of Participants',
    join: 'Join',
    increase_the_contribution: 'Increase Contribution',
    join_for: 'Join for',
    you_are_already_member: 'You are already a member',
    type: 'Type',
    deposit_amount: 'Deposit',
    owner: 'Owner',
    target: 'Target',
    ANY: 'any',
    FIXED: 'fixed',
    CHARITABLE: 'charitable',
    LOTTERY: 'lottery',
    exchange: {
      stars_for_tickets: 'Exchange stars for tickets',
    },
  },

  // small button
  button_small: {
    all: 'All',
  },

  // participants
  participants: {
    nickname_of_user: 'User Nickname',
    deposit_and_interest: 'Deposit & Interest',
    tickets_and_chance: 'Tickets & Chance',
    show_me: 'Show Me',
  },

  // confirmation info
  confirmation_info: {
    bank_type: 'Bank type',
    bank_name: 'Bank Name',
    target_of_bank: 'Target of bank',
    stars: '{{number}} stars',
    bank_will_available: 'The bank will be available',
    any: 'Any',
    amount_received_bank: 'Bank Entry Amount',
    from: 'from {{date}}',
    to: 'to {{date}}',
  },

  // referrals page
  referrals: {
    you_received: 'With the help of referrals, you received',
    my_referrals: 'My Referrals',
    invite_friends: 'Invite Friends',
  },

  replenishment: {
    title: 'Stars Replenishment',
    subtitle: 'Enter the amount to top up your Stars balance.',
  },

  // transactions page
  transactions_page: {
    today: 'Today',
    INVESTMENT: 'Investment',
    DEPOSIT: 'Deposit',
    TRANSFER: 'Transfer',
    WITHDRAWAL: 'Withdrawal',
    WIN: 'Win',
    LOSE: 'Lose',
  },

  transaction_input: {
    balance: 'Balance {{balance}}',
    not_commission: 'No commission',
    commission: 'Commission {{commission}}',
    remainder: 'Remainder',
    share_receipt: 'Share Receipt',
    contact_support: 'Contact Support',
    user_receive: 'receive ~ {{value}}',
  },

  transaction_details: {
    status: {
      text: 'Status',
      processing: 'Processing',
      completed: 'Completed',
    },
    receiver: 'Receiver',
    withdrawal_type: {
      telegram: 'Withdrawal to Telegram account',
      ton: 'Withdrawal to TON cryptocurrency',
    },
  },

  // notification page
  notifications_page: {
    title: 'Notifications',
    BOTTLE_WIN: 'Victory!',
    BOTTLE_LOOSE: 'Defeat :(',
    name_bank: 'Bank Name',
    owner: 'Owner',
    result: 'Result:',
  },

  months: {
    january: 'january',
    february: 'february',
    march: 'march',
    april: 'april',
    may: 'may',
    june: 'june',
    july: 'july',
    august: 'august',
    september: 'september',
    october: 'october',
    november: 'november',
    december: 'december',
  },

  sending_page: {
    title: 'Sending Stars',
    subtitle: 'Enter the username of the person you want to send Stars to.',
  },

  search_user: {
    results: 'Results',
    not_found: 'Not found...',
    invite_friend: 'Invite a friend to the system using the button above.',
  },

  sending_stars: {
    title: 'Sending Stars to {{username}}',
    subtitle: 'Enter the number of Stars you want to send.',
    button_text: 'Send',
  },

  withdrawal_page: {
    output_stars: 'Withdrawal of Stars',
    choose_preferred_method: 'Choose your preferred method of withdrawing Stars.',
    available: 'Available:',
    in_account: 'Into stars on account',
    in_ton: 'In USDT (TON network)',
    stars: {
      title: 'Withdrawal to real Stars on the account',
      subtitle: 'Enter the desired amount to withdraw Stars to your current account.',
      button_text: 'Withdraw',
    },
    ton: {
      title: 'Withdrawal to USDT cryptocurrency(TON network)',
      subtitle: 'Enter the desired amount starting from 500 Stars to withdraw to your Ton Wallet.',
      button_text: 'Withdraw',
      wallet: {
        address: 'Enter your Ton Wallet address.',
      },
    },
  },

  not_enough_stars: {
    title: 'Not enough Stars',
  },
  withdraw: {
    title: 'Enter at least 500 stars to withdraw.',
  },
  limit_is_full: {
    title: 'Your exchange limit has been reached',
  },

  error_page: {
    update: 'Update',
    support_service: 'Support Service',
    on_main: 'To Main',
    server: {
      title: 'Server Not Responding',
      description: 'There are connection issues. Please try again later.',
    },
    connect: {
      title: 'No Internet Connection',
      description: 'Your internet connection is interrupted. Please check the connection.',
    },
    technical: {
      title: 'Maintenance',
      description: 'The server is temporarily unavailable. Thank you for your patience!',
    },
    general: {
      failed_send: {
        title: 'Failed to Send',
        description: 'An error occurred while sending data. Please try again later.',
      },
      replenishment_failed: {
        title: 'Replenishment Failed',
        description: 'An error occurred during payment processing. Please try again later.',
      },
      something_went_wrong: {
        title: 'Something Went Wrong...',
        description: 'An error occurred. Please try again later or contact support.',
      },
      bank_not_created: {
        title: 'Bank Not Created',
        description: 'Failed to create a bank. Please try again later or contact support.',
      },
      output_failed: {
        title: 'Withdrawal Failed',
        description: 'We were unable to process your Stars withdrawal request. Please try again later.',
      },
      join_to_bottle_failed: {
        title: 'Failed to Join the Bottle',
        description: 'We couldn’t process the join request. Please try again later.',
      },
    },
  },

  // History participate
  history_participations: {
    label: 'History of participation',
    titles: {
      broken: 'Broken',
      unbroken: 'Unbroken',
    },
    bank: {
      titles: {
        WAITING: 'Waiting...',
        WIN: 'Victory!',
        DEFEAT: 'Defeat :(',
        name: 'Name of bank',
        owner: 'Owner',
        periodOfTime: 'Period of time',
      },
    },

    nothing: {
      title: 'Nothing here yet!',
      subtitle: 'You don’t have any broken jars yet.',
      show_bank: 'View jars',
    },

    missing: {
      title: 'Participation history is missing',
      description: 'You have not participated in any bank yet. Start now!',
      show_banks: 'View banks',
    },
  },

  // Confetti
  confetti: {
    type_of_confetti: {
      replenish: 'Replenishment successful!',
      send: 'Sending successful!',
      withdrawal: 'Request received!',
    },
    description: {
      replenish: 'Your Stars account balance has been successfully replenished.',
      send: '{{numberOfStars}} Stars have been successfully sent to {{username}}.',
      withdrawal: 'You can track the status in "Transactions". Processing may take up to 24 hours.',
    },
    button: {
      on_main: 'On main page',
      show_banks: 'View the banks',
    },
  },
}
